import getConfig from "src/config/appConfig";
import agendaApiConfig from "./agendaApiConfig";

export const ServiceWaitList = {
  async saveWaitList(body) {
    return await agendaApiConfig.post(`/listaespera/guardar`, body);
  },
  async getSpecialities(date) {
    const { SERVICIO } = getConfig();
    return await agendaApiConfig.get(`/listaespera/especialidades`, {
      params: {
        SER_CODIGO: SERVICIO,
        date,
      },
    });
  },
  async getProfessionals(esp_codigo = 0, date) {
    const { SERVICIO } = getConfig();
    return await agendaApiConfig.get(`/listaespera/especialistas`, {
      params: {
        SER_CODIGO: SERVICIO,
        esp_codigo: esp_codigo || 0,
        date,
      },
    });
  },
  async getSpecialitiesByProfessional(ptdRut) {
    return await agendaApiConfig.get(`/especialidad/profesional`, {
      params: {
        rut: ptdRut,
      },
    });
  },
};
